import { getEnv } from "./env";
const { GOLDEN_GATE } = getEnv();
const isCacaUser = (user) => user && user._id && user._id.$oid !== undefined;
const isEmployee = (traits) => {
  return (
    traits.email &&
    typeof traits.email === "string" &&
    (traits.email.indexOf("@autodesk.com") > 0 ||
      traits.email.indexOf("@plangrid.com") > 0)
  );
};
const getDomain = (email) => email.slice(email.indexOf("@") + 1);
export default function sanitizeTraits(traits) {
  traits = traits || {};
  if (GOLDEN_GATE) {
    // Spec for these properties: https://wiki.autodesk.com/pages/viewpage.action?pageId=664366824
    return {
      oxygen_user_id: traits.autodeskId || traits.oxygenId,
      oxygen_analytics_id: traits.analyticsId,
      email: typeof traits.email === "string" ? traits.email : undefined,
      domain:
        typeof traits.email === "string"
          ? getDomain(traits.email).toLowerCase()
          : undefined,
      is_employee: isEmployee(traits),
      name:
        typeof traits.name === "string" &&
        traits.name
          .split(" ")
          .map((n) => n.charAt(0))
          .join("")
          .toUpperCase(),
    };
  } else if (isCacaUser(traits)) {
    return {
      id: traits._id && traits._id.$oid,
      uid: traits._id && traits._id.$oid,
      language: traits.lang,
      joined_at: traits.joined_on && traits.joined_on.$date,
      payment_type: traits.payment.payment_type,
      plan: traits.plan,
    };
  } else {
    return {
      id: traits.uid,
      uid: traits.uid,
      language: traits.language,
      joined_at: traits.joined_on,
      payment_type: traits.payment_type,
      plan: traits.plan,
      is_employee: isEmployee(traits),
    };
  }
}
